<mat-toolbar class="mat-elevation-z4 sticky z-10 toolbar" style="top: 0">
  <mat-toolbar-row>
    @if (isHandset$ | async) {
      <button
        type="button"
        aria-label="Toggle sidenav"
        mat-icon-button
        (click)="toggleDrawer.emit()"
        >
        <app-icon icon="menu"></app-icon>
      </button>
    }
    <span>{{ title$ | async }}</span>
    <app-save-indicator></app-save-indicator>
      @if (resolverStatus.resolving()) {
          <app-icon icon="spinner" [spin]="true"></app-icon>
      }
    <span class="w-full"></span>
    <app-document-indicator></app-document-indicator>
    <app-export></app-export>
    <!--
    <app-action-indicator></app-action-indicator>
    -->
      @if (shipmentToolbar$ | async) {
          @if (currentView() === 'editor') {
              <button type="button" matIconButton [matMenuTriggerFor]="shipmentMenu">
                  <app-icon icon="context-menu"></app-icon>
              </button>
              <mat-menu #shipmentMenu>
                  <button mat-menu-item (click)="swapEditorAddresses()" i18n>
                      Swap Shipper and Destination
                  </button>
                  <button mat-menu-item (click)="openDocumentUpload()" i18n>
                      Upload Document
                  </button>
              </mat-menu>
          }
      }
    <button type="button" matIconButton (click)="toggleSearch.emit()">
      <app-icon icon="search"></app-icon>
    </button>
    <a (click)="openProfileDialog()" class="cursor-pointer ml-2">
      <app-profile-avatar></app-profile-avatar>
    </a>
  </mat-toolbar-row>
  @if (shipmentToolbar$ | async) {
    <mat-toolbar-row class="flex flex-row gap-2">
        @if (currentView() === 'editor') {
            <app-shipment-category></app-shipment-category>
            @if (displayUndoRedo$ | async) {
                <app-shipment-undo-redo></app-shipment-undo-redo>
            }
      }
      <span class="w-full"></span>
      @if (currentView() === 'quotes') {
        <button i18n mat-button (click)="showEditor()">
            Edit Shipment
        </button>
      }
      @if (currentView() === 'editor') {
        <div>
          @if ((editorValid$ | async) && !(validQuotesAvailable | async)) {
            <button i18n mat-button (click)="startQuoting()" class="mr-2">
                Get Quotes
            </button>
          }
          @if ((editorValid$ | async) && (validQuotesAvailable | async)) {
            <button i18n mat-button (click)="showQuotes()" class="mr-2">
                View Quotes
            </button>
          }
        </div>
      }
      @if (canVoid$ | async) {
        <button i18n mat-button (click)="voidShipment()" class="mr-2">
            Void
        </button>
      }
      @if (canBookPickup$ | async) {
        <button i18n mat-button (click)="bookPickup()" class="mr-2">
            Book Pickup
        </button>
      }
      @if (canCancelPickup$ | async) {
        <button i18n mat-button (click)="cancelPickup()" class="mr-2">
            Cancel Pickup
        </button>
      }
      @if (canPrintWaybills$ | async) {
        <button i18n mat-button (click)="printWaybills()" class="mr-2">
            Print Labels
        </button>
      }
      @if (displayQuoting()) {
        <div>
          @if (!(busy$ | async)) {
            <button i18n mat-button (click)="startQuoting()" class="mr-2">
                Requote
            </button>
          }
        </div>
      }
      @if (busy$ | async) {
        <div class="mr-2">
          <app-icon icon="spinner" [spin]="true"></app-icon>
        </div>
      }
    </mat-toolbar-row>
  }
</mat-toolbar>
